import React from 'react'
import { SlideDown } from 'react-slidedown'
import PropTypes from 'prop-types'
import 'react-slidedown/lib/slidedown.css'

class ElementSlider extends React.Component {
  constructor (props) {
    super(props)
    this.slider = React.createRef()
  }

  componentDidMount () {
    this.slider.current.addEventListener('transitionend', e => {
      if (this.props.open && this.props.onAfterOpen) {
        this.props.onAfterOpen(e)
      } else if (!this.props.open && this.props.onAfterClose) {
        this.props.onAfterClose(e)
      }
    })
  }

  render () {
    return (
      <SlideDown
        className={this.props.sliderClass}
        closed={!this.props.open}
        ref={this.slider}
      >
        {this.props.children}
      </SlideDown>
    )
  }
}

ElementSlider.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  onAfterClose: PropTypes.func,
  onAfterOpen: PropTypes.func,
  sliderClass: PropTypes.string
}

export default ElementSlider
